/**
 *  @class
 *  @function Predictive Search
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');

      this.setupEventListeners();

    }
    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.predictiveSearchResults.addEventListener('focusout', this.close.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.cc.addEventListener('click', this.close.bind(this));

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
      this.input.addEventListener('focus', this.open.bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) {
        document.body.classList.remove('open-search');
        this.predictiveSearchResults.setAttribute('inert', '');
        return;
      }
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        return;
      }

      this.getSearchResults(searchTerm);
    }

    // getSearchResults(searchTerm) {

    //   this.predictiveSearchResults.classList.add('loading');

    //   // fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,collection&${encodeURIComponent('resources[limit]')}=20&section_id=predictive-search`)
    //   fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,query,collection&${encodeURIComponent('resources[limit]')}=50&section_id=predictive-search`)

    //   .then((response) => {
    //       this.predictiveSearchResults.classList.remove('loading');
    //       if (!response.ok) {
    //         var error = new Error(response.status);
    //         throw error;
    //       }

    //       return response.text();
    //     })
    //     .then((text) => {
    //       const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

    //       this.renderSearchResults(resultsMarkup);
    //     })
    //     .catch((error) => {
    //       throw error;
    //     });
    // }

    
    getSearchResults(searchTerm) {
  this.predictiveSearchResults.classList.add('loading');

  // Fetch products, collections, queries
  const productUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`;
  const collectionUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=collection&resources%5Blimit%5D=10&section_id=predictive-search`;
  const queryUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=query&resources%5Blimit%5D=10&section_id=predictive-search`;

  Promise.all([fetch(productUrl), fetch(collectionUrl), fetch(queryUrl)])
    .then(responses => Promise.all(responses.map(response => response.text())))
    .then(([productText, collectionText, queryText]) => {
      const parser = new DOMParser();

      // --- Products ---
      const productDoc = parser.parseFromString(productText, 'text/html');
      const productItems = productDoc.querySelectorAll('.product-cart-item'); // adjust selector if needed
      const limitedProducts = Array.from(productItems)
        .slice(0, 5) 
        .map(el => el.outerHTML)
        .join('');

      // --- Collections ---
      const collectionDoc = parser.parseFromString(collectionText, 'text/html');
      const collectionContent = collectionDoc.querySelector('.thb-predictive-search--content');
      const collectionResults = collectionContent ? collectionContent.innerHTML : '';

      // --- Queries ---
      const queryDoc = parser.parseFromString(queryText, 'text/html');
      const queryContent = queryDoc.querySelector('.thb-predictive-search--content');
      const queryResults = queryContent ? queryContent.innerHTML : '';

      // --- View all button (take only once) ---
      const viewAllButton = productDoc.querySelector('.thb-predictive-search--footer');

      // --- Final Markup ---
      // const finalMarkup = `
      //   <div class="thb-predictive-search--content">
      //     ${limitedProducts}
      //     ${collectionResults}
      //     ${queryResults}
      //   </div>
      //   ${viewAllButton ? viewAllButton.outerHTML : ''}
      // `;

      const finalMarkup = `
        <div class="thb-predictive-search--container">
          <div class="thb-predictive-search--content">
            ${limitedProducts}
            ${collectionResults}
            ${queryResults}
          </div>
          ${viewAllButton ? viewAllButton.outerHTML : ''}
        </div>
      `;

      this.renderSearchResults(finalMarkup);
    })
    .catch(error => {
      console.error("Error fetching search results:", error);
    })
    .finally(() => {
      this.predictiveSearchResults.classList.remove('loading');
    });
}

// end



// getSearchResults(searchTerm) {
//   this.predictiveSearchResults.classList.add('loading');

//   const productUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`;
//   const collectionUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=collection&resources%5Blimit%5D=10&section_id=predictive-search`;
//   const queryUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=query&resources%5Blimit%5D=10&section_id=predictive-search`;

//   Promise.all([fetch(productUrl), fetch(collectionUrl), fetch(queryUrl)])
//     .then(responses => Promise.all(responses.map(response => response.text())))
//     .then(([productText, collectionText, queryText]) => {
//       const parser = new DOMParser();

//       const productDoc = parser.parseFromString(productText, 'text/html');
//       const collectionDoc = parser.parseFromString(collectionText, 'text/html');
//       const queryDoc = parser.parseFromString(queryText, 'text/html');

//       const productResults = productDoc.querySelector('.thb-predictive-search--content')?.innerHTML || '';
//       const collectionResults = collectionDoc.querySelector('.thb-predictive-search--content')?.innerHTML || '';
//       const queryResults = queryDoc.querySelector('.thb-predictive-search--content')?.innerHTML || '';

//       // ✅ Only one footer
//       let viewAll = '';
//       const productFooter = productDoc.querySelector('.thb-predictive-search--footer');
//       if (productFooter) {
//         viewAll = productFooter.outerHTML;
//       }

//       const finalMarkup = `
//         <div class="thb-predictive-search--content">
//           ${productResults}
//           ${collectionResults}
//           ${queryResults}
//         </div>
//         ${viewAll}
//       `;

//       this.predictiveSearchResults.classList.remove('loading');
//       this.renderSearchResults(finalMarkup);
//     })
//     .catch(error => {
//       console.error("Error fetching search results:", error);
//       this.predictiveSearchResults.classList.remove('loading');
//     });
// }



  //    getSearchResults(searchTerm) {
  //   this.predictiveSearchResults.classList.add('loading');

  //   // Fetch products
  //   const productUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`;
  //   const collectionUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=collection&resources%5Blimit%5D=10&section_id=predictive-search`;
  //   const queryUrl = `/search/suggest?q=${encodeURIComponent(searchTerm)}&resources%5Btype%5D=query&resources%5Blimit%5D=10&section_id=predictive-search`;

  //   Promise.all([fetch(productUrl), fetch(collectionUrl), fetch(queryUrl)])
  //     .then(responses => Promise.all(responses.map(response => response.text())))
  //     .then(([productText, collectionText, queryText]) => {
  //       const productResults = new DOMParser().parseFromString(productText, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
  //       const collectionResults = new DOMParser().parseFromString(collectionText, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
  //       const queryResults = new DOMParser().parseFromString(queryText, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

  //       // Combine all results into one
  //       this.renderSearchResults(productResults + collectionResults + queryResults);
  //     })
  //     .catch(error => {
  //       console.error("Error fetching search results:", error);
  //     });
  // }

  
    renderSearchResults(resultsMarkup) {
      
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      let submitButton = this.querySelector('#search-results-submit');

      // submitButton.addEventListener('click', () => {
      //   this.form.submit();
      // });

      if (submitButton) {
        submitButton.addEventListener('click', () => {
          this.form.submit();
        });
      }
    }

    close() {
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search');
    }
    open() {
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
    }
  }
  customElements.define('search-form', SearchForm);
}




// document.addEventListener('DOMContentLoaded', function() {
//   const searchInput = document.getElementById('header-search-input');

//   if(searchInput){
//     searchInput.addEventListener('click', function() {
//       alert('Hello');
//     });
//   } else {
//     console.warn('header-search-input element not found!');
//   }
// });



// document.addEventListener('DOMContentLoaded', function() {
//   const searchInput = document.getElementById('header-search-input');

//   if(searchInput){
//     searchInput.addEventListener('click', function(e) {
//       e.preventDefault(); // default action roko agar koi form hai

//       // Overlay create karna
//       let overlay = document.getElementById('search-overlay');
//       if(!overlay){
//         overlay = document.createElement('div');
//         overlay.id = 'search-overlay';
//         overlay.style.position = 'fixed';
//         overlay.style.top = '0';
//         overlay.style.left = '0';
//         overlay.style.width = '100%';
//         overlay.style.height = '100%';
//         overlay.style.backgroundColor = 'rgba(255,255,255,0.95)';
//         overlay.style.zIndex = '9999';
//         overlay.style.display = 'flex';
//         overlay.style.flexDirection = 'column';
//         overlay.style.justifyContent = 'flex-start';
//         overlay.style.alignItems = 'center';
//         // overlay.style.paddingTop = '50px';

        
//         // Close button
//         const closeBtn = document.createElement('button');
//         closeBtn.innerText = '×';
//         closeBtn.style.fontSize = '30px';
//         closeBtn.style.position = 'absolute';
//         closeBtn.style.top = '20px';
//         closeBtn.style.right = '20px';
//         closeBtn.style.background = 'transparent';
//         closeBtn.style.border = 'none';
//         closeBtn.style.cursor = 'pointer';
//         overlay.appendChild(closeBtn);

//         // Search input
//         const input = document.createElement('input');
//         input.type = 'search';
//         input.placeholder = 'Search...';
//         input.style.width = '300px';
//         input.style.padding = '10px 15px';
//         input.style.fontSize = '18px';
//         input.style.border = '1px solid #ccc';
//         input.style.borderRadius = '6px';
//         overlay.appendChild(input);

//         closeBtn.addEventListener('click', function() {
//           overlay.remove();
//           document.body.style.overflow = 'auto';
//         });

//         document.body.appendChild(overlay);
//         document.body.style.overflow = 'hidden';

//         input.focus(); // input par focus
//       }
//     });
//   } else {
//     console.warn('header-search-input element not found!');
//   }
// });










// document.addEventListener('DOMContentLoaded', function() {
//   const searchInput = document.getElementById('header-search-input');
//   if (!searchInput) return;


//    // Save original wrapper HTML and parent
//   const originalWrapper = searchInput.parentElement;
//   const originalHTML = originalWrapper.innerHTML;
// // Save original parent before moving input
// const originalParent = searchInput.parentElement;

  
//   searchInput.addEventListener('click', function(e) {
//     // e.preventDefault();

//     // Only for mobile view
//     if (window.innerWidth > 768) return;
//     e.preventDefault();

//     let overlay = document.getElementById('mobile-search-overlay');
    
//     if (!overlay) {
//       // Overlay
//       overlay = document.createElement('div');
//       overlay.id = 'mobile-search-overlay';
//       // overlay.style.position = 'fixed';
//       // overlay.style.top = '0';
//       // overlay.style.left = '0';
//       // overlay.style.width = '100%';
//       // overlay.style.height = '100%';
//       // overlay.style.backgroundColor = '#fff';
//       // overlay.style.zIndex = '9999';
//       // overlay.style.display = 'flex';
//       // overlay.style.flexDirection = 'column';
//       // overlay.style.padding = '20px';
//       // overlay.style.overflowY = 'auto';
//        overlay.style = `
//       position: fixed; top: 0; left: 0; width: 100%; height: 100%;
//       background: #fff; z-index: 9999; display: flex; flex-direction: column;
//       padding: 20px; overflow-y: auto;
//     `;
//       overlay.style.pointerEvents = 'auto'; 


//       // Close button
//       const closeBtn = document.createElement('button');
//       closeBtn.innerText = '×';
//       // closeBtn.style.fontSize = '28px';
//       // closeBtn.style.alignSelf = 'flex-end';
//       // closeBtn.style.background = 'transparent';
//       // closeBtn.style.border = 'none';
//       // closeBtn.style.cursor = 'pointer';
//       closeBtn.style = `
//         font-size: 28px; align-self: flex-end;
//         background: transparent; border: none; cursor: pointer;
//       `;
//       overlay.appendChild(closeBtn);

//       // Input wrapper
//       const inputWrapper = document.createElement('div');
//       inputWrapper.style.position = 'relative';
//       overlay.appendChild(inputWrapper);

//       // Move input into wrapper
//       inputWrapper.appendChild(searchInput);
//       searchInput.style.width = '100%';
//       searchInput.style.fontSize = '16px';
//       searchInput.style.padding = '10px 15px';

// const inputClearBtn = document.createElement('button');

// inputClearBtn.innerText = '×';
// // inputClearBtn.style.position = 'absolute';
// // inputClearBtn.style.right = '10px';
// // inputClearBtn.style.top = '35%';
// // inputClearBtn.style.transform = 'translateY(-50%)';  // vertical center
// // inputClearBtn.style.fontSize = '22px';               // size bada
// // inputClearBtn.style.width = '28px';                 // button width
// // inputClearBtn.style.height = '28px';                // button height
// // inputClearBtn.style.lineHeight = '28px';            // text vertical align
// // inputClearBtn.style.textAlign = 'center';           // text center horizontally
// // inputClearBtn.style.border = 'none';
// // inputClearBtn.style.borderRadius = '50%';           // circular button
// // inputClearBtn.style.background = 'rgba(0,0,0,0.1)'; // thoda background
// // inputClearBtn.style.cursor = 'pointer';
// // inputClearBtn.style.display = 'flex';               
// // inputClearBtn.style.alignItems = 'center';          // vertical center
// // inputClearBtn.style.justifyContent = 'center';      // horizontal center

//    inputClearBtn.style = `
//       position: absolute; right: 10px; top: 35%; transform: translateY(-50%);
//       font-size: 22px; width: 28px; height: 28px; line-height: 28px; text-align: center;
//       border: none; border-radius: 50%; background: rgba(0,0,0,0.1);
//       cursor: pointer; display: flex; align-items: center; justify-content: center;
//     `;

// inputWrapper.appendChild(inputClearBtn);

// inputClearBtn.addEventListener('click', () => {
//   searchInput.value = '';        // input clear
//   resultsContainer.innerHTML = ''; // results clear
//   searchInput.focus();           // focus wapas
// });


//       if (document.activeElement) document.activeElement.blur();
//       requestAnimationFrame(() => {
//         setTimeout(() => searchInput.focus(), 50);
//       });

//       // Results container just below input
//       const resultsContainer = document.createElement('div');
//       resultsContainer.className = 'thb-predictive-search--container';
//       // resultsContainer.style.pointerEvents = 'auto';
//       // resultsContainer.style.position = 'absolute';
//       // resultsContainer.style.top = '100%';
//       // resultsContainer.style.left = '0';
//       // resultsContainer.style.width = '100%';
//       // resultsContainer.style.backgroundColor = '#fff';
//       // resultsContainer.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
//       // resultsContainer.style.maxHeight = '300px';
//       // resultsContainer.style.overflowY = 'auto';
//       // resultsContainer.style.zIndex = '1000';
      
//       // resultsContainer.style = `
//       //   position: absolute; top: 100%; left: 0; width: 100%;
//       //   background: #fff; box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//       //   max-height: 300px; overflow-y: auto; z-index: 1000;
//       // `;

//       resultsContainer.style = `
//         width: 100%;
//         background: #fff;
//         box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//         max-height: 300px;
//         overflow-y: auto;
//         z-index: 1000;
//         margin-top: 10px;
//       `;

      
//       inputWrapper.appendChild(resultsContainer);


//       // closeBtn.addEventListener('click', () => {
//       //   // alert('hello');
//       //   overlay.remove();
//       //   searchInput.focus();

//       // });

//       // closeBtn.addEventListener('click', () => {
//       //     // Remove overlay
//       //     overlay.remove();

//       //     // Reset input
//       //     searchInput.value = '';

//       //     // Clear any predictive search results
//       //     const resultsContainer = document.querySelector('.thb-predictive-search--container');
//       //     if (resultsContainer) resultsContainer.innerHTML = '';

//       //     // Restore body scroll
//       //     document.body.style.overflow = 'auto';

//       //     // Focus back to input if needed
//       //     searchInput.focus();
//       // });
// closeBtn.addEventListener('click', () => {
//     // Remove overlay (also removes resultsContainer)
//     overlay.remove();

//     // Restore body scroll
//     document.body.style.overflow = 'auto';

//     // Move search input back to its original parent
//     if (!originalParent.contains(searchInput)) {
//         originalParent.appendChild(searchInput);
//     }

//     // Clear input value
//     searchInput.value = '';

//     // Remove any predictive search results from original parent (just in case)
//     const oldResults = originalParent.querySelector('.thb-predictive-search--container');
//     if (oldResults) oldResults.remove();

//     // Focus back on input
//     searchInput.focus();
// });


//       document.body.appendChild(overlay);
//       document.body.style.overflow = 'hidden';

//       searchInput.addEventListener('input', debounce(function() {
//       const query = searchInput.value.trim();

//       if (query.length === 0) {
//         resultsContainer.innerHTML = '';
//         return;
//       }

//       if (query.length < 2) {
//         resultsContainer.innerHTML = '';
//         return;
//       }
  
//       // fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=5&section_id=predictive-search`)
//       fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`)

//         .then(res => res.text())
//         .then(html => {
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, 'text/html');
//           const content = doc.querySelector('.thb-predictive-search--container') || doc.querySelector('#shopify-section-predictive-search');

//           resultsContainer.innerHTML = content ? content.innerHTML : '<p>No results found</p>';
//         })
//         .catch(err => {
//           console.error(err);
//           resultsContainer.innerHTML = '<p>Error fetching results</p>';
//         });
//     }, 300));

//     }
//   });
// });

// // Debounce function
// function debounce(fn, delay) {
//   let timer;
//   return function(...args) {
//     clearTimeout(timer);
//     timer = setTimeout(() => fn.apply(this, args), delay);
//   };
// }












// document.addEventListener('DOMContentLoaded', function() {
//   const searchInput = document.getElementById('header-search-input');
//   if (!searchInput) return;

//   // Save original parent
//   const originalParent = searchInput.parentElement;

//   searchInput.addEventListener('click', function(e) {
//     if (window.innerWidth > 768) return; // Only mobile
//     e.preventDefault();

//     let overlay = document.getElementById('mobile-search-overlay');

//     if (!overlay) {
//       // Create overlay
//       overlay = document.createElement('div');
//       overlay.id = 'mobile-search-overlay';
//       // overlay.style = `
//       //   position: fixed; top: 0; left: 0; width: 100%; height: 100%;
//       //   background: #fff; z-index: 9999; display: flex; flex-direction: column;
//       //   padding: 20px; overflow-y: auto; pointer-events: auto;
//       // `;

//         overlay.style = `
//   position: fixed; top: 0; left: 0; width: 100%; height: 100%;
//   background: #fff; z-index: 9999; display: flex; flex-direction: column;
//   padding: 20px; overflow-y: auto;
//   pointer-events: auto;
// `;


//       // Close button
//       const closeBtn = document.createElement('button');
//       closeBtn.innerText = '×';
//       closeBtn.style = `
//         font-size: 28px; align-self: flex-end;
//         background: transparent; border: none; cursor: pointer;
//       `;
//       overlay.appendChild(closeBtn);

//       // Input wrapper
//       const inputWrapper = document.createElement('div');
//       inputWrapper.style.position = 'relative';
//       overlay.appendChild(inputWrapper);

//       // Move input to overlay
//       inputWrapper.appendChild(searchInput);
//       searchInput.style.width = '100%';
//       searchInput.style.fontSize = '16px';
//       searchInput.style.padding = '10px 15px';

//       // Clear button
//       const inputClearBtn = document.createElement('button');
//       inputClearBtn.innerText = '×';
//       inputClearBtn.style = `
//         position: absolute; right: 10px; top: 35%; transform: translateY(-50%);
//         font-size: 22px; width: 28px; height: 28px; line-height: 28px; text-align: center;
//         border: none; border-radius: 50%; background: rgba(0,0,0,0.1);
//         cursor: pointer; display: flex; align-items: center; justify-content: center;
//       `;
//       inputWrapper.appendChild(inputClearBtn);

//       // Results container
//       const resultsContainer = document.createElement('div');
//       resultsContainer.className = 'thb-predictive-search--container';
//       resultsContainer.style = `
//         width: 100%; background: #fff;
//         box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//         max-height: 300px; overflow-y: auto; z-index: 1000; margin-top: 10px;
//       `;
//       inputWrapper.appendChild(resultsContainer);

//       // Focus input
//       requestAnimationFrame(() => setTimeout(() => searchInput.focus(), 50));

//       // Clear input on clear button click
//       inputClearBtn.addEventListener('click', () => {
//         searchInput.value = '';
//         resultsContainer.innerHTML = '';
//         searchInput.focus();
//       });

//       // Close overlay
//       closeBtn.addEventListener('click', () => {
//         overlay.remove();
//         document.body.style.overflow = 'auto';

//         if (!originalParent.contains(searchInput)) {
//           originalParent.appendChild(searchInput);
//         }

//         searchInput.value = '';
//         const oldResults = originalParent.querySelector('.thb-predictive-search--container');
//         if (oldResults) oldResults.remove();

//         searchInput.focus();
//       });

//       document.body.appendChild(overlay);
//       document.body.style.overflow = 'hidden';

//       // Input event for predictive search
//       searchInput.addEventListener('input', debounce(function() {
//         const query = searchInput.value.trim();

//         if (query.length < 2) {
//           resultsContainer.innerHTML = '';
//           return;
//         }

//   //       fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`)
//   //         .then(res => res.text())
//   //         .then(html => {
//   //           const parser = new DOMParser();
//   //           const doc = parser.parseFromString(html, 'text/html');
//   //           const content = doc.querySelector('.thb-predictive-search--container') || doc.querySelector('#shopify-section-predictive-search');

//   //           // resultsContainer.innerHTML = content ? content.innerHTML : '<p>No results found</p>';

//   //           // // Make "View All Results" clickable
//   //           // setTimeout(() => {
//   //           //   const viewAllBtn = resultsContainer.querySelector('.view-all-results-button'); // adjust selector
//   //           //   if (viewAllBtn) {
//   //           //     viewAllBtn.addEventListener('click', (e) => {
//   //           //       e.stopPropagation();
//   //           //       const href = viewAllBtn.getAttribute('href');
//   //           //       if (href) window.location.href = href;
//   //           //     });
//   //           //   }
//   //           // }, 100);

//   //           // After injecting results HTML
//   //           resultsContainer.innerHTML = content ? content.innerHTML : '<p>No results found</p>';

//   //           // Event delegation for dynamically loaded buttons
//   //           resultsContainer.addEventListener('click', function(e) {
//   //             const btn = e.target.closest('.view-all-results-button'); // adjust selector
//   //             if (!btn) return;

//   //             e.preventDefault();

//   //             // Get current input value
//   //             const query = encodeURIComponent(searchInput.value.trim());
//   //             const query = encodeURIComponent(searchInput.value.trim());
//   // const searchURL = `/search?q=${query}`;
//   // window.location.href = searchURL;
//   //             if (!query) return;

//   //             // Redirect to search page with current query
//   //             const searchURL = `/search?q=${query}`;
//   //             window.location.href = searchURL;
//   //           });


//   //         })
//    fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`)
//           .then(res => res.text())
//           .then(html => {
//             const parser = new DOMParser();
//             const doc = parser.parseFromString(html, 'text/html');
//             const content = doc.querySelector('.thb-predictive-search--container') || doc.querySelector('#shopify-section-predictive-search');
//             resultsContainer.innerHTML = content ? content.innerHTML : '<p>No results found</p>';

//             // Event delegation for "View All Results" button
//             // resultsContainer.addEventListener('click', function(e) {
//             //   const btn = e.target.closest('.view-all-results-button'); // adjust selector
//             //   if (!btn) return;
//             //   e.preventDefault();
//             //   const currentQuery = encodeURIComponent(searchInput.value.trim());
//             //   const href = btn.getAttribute('href') || `/search?q=${currentQuery}`;
//             //   window.location.href = href;
//             // });

//             // After creating resultsContainer
//             resultsContainer.classList.remove('inert');
//             resultsContainer.style.pointerEvents = 'auto';

//             // Attach click listener ONCE
//             resultsContainer.addEventListener('click', function(e) {
//               const btn = e.target.closest('.view-all-results-button');
//               if (!btn) return;
//               e.preventDefault();

//               const query = encodeURIComponent(searchInput.value.trim());
//               const href = btn.getAttribute('href') || `/search?q=${query}`;

//               window.location.href = href;
//             });

//           })

//           .catch(err => {
//             console.error(err);
//             resultsContainer.innerHTML = '<p>Error fetching results</p>';
//           });

//       }, 300));
//     }
//   });
// });

// // Debounce function
// function debounce(fn, delay) {
//   let timer;
//   return function(...args) {
//     clearTimeout(timer);
//     timer = setTimeout(() => fn.apply(this, args), delay);
//   };
// }















// document.addEventListener('DOMContentLoaded', function() {
//   const searchInput = document.getElementById('header-search-input');
//   if (!searchInput) return;

//   const originalParent = searchInput.parentElement;

//   searchInput.addEventListener('click', function(e) {
//     if (window.innerWidth > 768) return; // Only mobile
//     e.preventDefault();

//     let overlay = document.getElementById('mobile-search-overlay');
//     if (!overlay) {
//       // Create overlay
//       overlay = document.createElement('div');
//       overlay.id = 'mobile-search-overlay';
//       overlay.style = `
//         position: fixed; top: 0; left: 0; width: 100%; height: 100%;
//         background: #fff; z-index: 9999; display: flex; flex-direction: column;
//         padding: 20px; overflow-y: auto; pointer-events: auto;
//       `;

//       // Close button
//       const closeBtn = document.createElement('button');
//       closeBtn.innerText = '×';
//       closeBtn.style = `
//         font-size: 28px; align-self: flex-end;
//         background: transparent; border: none; cursor: pointer;
//       `;
//       overlay.appendChild(closeBtn);

//       // Input wrapper
//       const inputWrapper = document.createElement('div');
//       inputWrapper.style.position = 'relative';
//       overlay.appendChild(inputWrapper);

//       // Move input
//       inputWrapper.appendChild(searchInput);
//       searchInput.style.width = '100%';
//       searchInput.style.fontSize = '16px';
//       searchInput.style.padding = '10px 15px';

//       // Clear button
//       const inputClearBtn = document.createElement('button');
//       inputClearBtn.innerText = '×';
//       inputClearBtn.style = `
//         position: absolute; right: 10px; top: 35%; transform: translateY(-50%);
//         font-size: 22px; width: 28px; height: 28px; line-height: 28px; text-align: center;
//         border: none; border-radius: 50%; background: rgba(0,0,0,0.1);
//         cursor: pointer; display: flex; align-items: center; justify-content: center;
//       `;
//       inputWrapper.appendChild(inputClearBtn);

//       // Results container
//       const resultsContainer = document.createElement('div');
//       resultsContainer.className = 'thb-predictive-search--container';
//       resultsContainer.style = `
//         width: 100%; background: #fff;
//         box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//         max-height: 300px; overflow-y: auto; z-index: 1000; margin-top: 10px;
//         pointer-events: auto;
//       `;
//       inputWrapper.appendChild(resultsContainer);

//       // Focus input
//       requestAnimationFrame(() => setTimeout(() => searchInput.focus(), 50));

//       // Clear button
//       inputClearBtn.addEventListener('click', () => {
//         searchInput.value = '';
//         resultsContainer.innerHTML = '';
//         searchInput.focus();
//       });

//       // Close overlay
//       closeBtn.addEventListener('click', () => {
//         overlay.remove();
//         document.body.style.overflow = 'auto';
//         if (!originalParent.contains(searchInput)) originalParent.appendChild(searchInput);
//         searchInput.value = '';
//         const oldResults = originalParent.querySelector('.thb-predictive-search--container');
//         if (oldResults) oldResults.remove();
//         searchInput.focus();
//       });

//       document.body.appendChild(overlay);
//       document.body.style.overflow = 'hidden';

//       // // ✅ Attach click listener ONCE for "View All Results"
//       // resultsContainer.addEventListener('click', function(e) {
//       //   const btn = e.target.closest('.view-all-results-button');
//       //   if (!btn) return; // Only run for the button

//       //   const searchQuery = encodeURIComponent(searchInput.value.trim());
//       //   const href = btn.getAttribute('href') || `/search?q=${searchQuery}`;
//       //   window.location.href = href;
//       // });


//       /// ✅ Delegate click for "View All Results"
// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('.view-all-results-button, .thb-predictive-search--footer a');
//   if (!btn || !document.body.contains(btn)) return;

//   e.preventDefault();

//   const searchQuery = encodeURIComponent(searchInput.value.trim());
//   const href = btn.getAttribute('href') || `/search?q=${searchQuery}`;

//   // पहले overlay हटाओ
//   overlay.remove();
//   document.body.style.overflow = 'auto';
//   if (!originalParent.contains(searchInput)) {
//     originalParent.appendChild(searchInput);
//   }

//   // 👉 Alert for debug
//   alert("View All Results clicked! Href: " + href);

//   // फिर redirect
//   window.location.href = href;
// });



//       // Input event for predictive search
//       searchInput.addEventListener('input', debounce(function() {
//         const query = searchInput.value.trim();
//         if (query.length < 2) {
//           resultsContainer.innerHTML = '';
//           return;
//         }

//         fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`)
//           .then(res => res.text())
//           .then(html => {
//             const parser = new DOMParser();
//             const doc = parser.parseFromString(html, 'text/html');
//             const content = doc.querySelector('.thb-predictive-search--container') || doc.querySelector('#shopify-section-predictive-search');
//             resultsContainer.innerHTML = content ? content.innerHTML : '<p>No results found</p>';
//           })
//           .catch(err => {
//             console.error(err);
//             resultsContainer.innerHTML = '<p>Error fetching results</p>';
//           });
//       }, 300));
//     }
//   });
// });

// // Debounce function
// function debounce(fn, delay) {
//   let timer;
//   return function(...args) {
//     clearTimeout(timer);
//     timer = setTimeout(() => fn.apply(this, args), delay);
//   };
// }










document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('header-search-input');
  if (!searchInput) return;

  const originalParent = searchInput.parentElement;

  // searchInput.addEventListener('click', function(e) {
  searchInput.addEventListener('focus', function(e) {

    if (window.innerWidth > 768) return; // Only mobile
    e.preventDefault();


  // Already open? Skip creating again
  if (document.getElementById('mobile-search-overlay')) return;

    let overlay = document.getElementById('mobile-search-overlay');
    if (!overlay) {
      // Create overlay
      overlay = document.createElement('div');
      overlay.id = 'mobile-search-overlay';
      overlay.style = `
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: #fff; z-index: 9999; display: flex; flex-direction: column;
        padding: 15px; overflow-y: auto; pointer-events: auto; font-size:12px;
      `;

      // Close button
      const closeBtn = document.createElement('button');
      closeBtn.innerText = '×';
      closeBtn.style = `
        font-size: 28px; align-self: flex-end;
        background: transparent; border: none; cursor: pointer;
      `;
      overlay.appendChild(closeBtn);

      // Input wrapper
      const inputWrapper = document.createElement('div');
      inputWrapper.style.position = 'relative';
      overlay.appendChild(inputWrapper);

      // Move input
      inputWrapper.appendChild(searchInput);
      searchInput.style.width = '100%';
      // searchInput.style.fontSize = '16px';
      // searchInput.style.padding = '10px 15px';
      inputWrapper.style.position = 'relative';
      inputWrapper.style.height = searchInput.offsetHeight + 'px'; // wrapper height same as input


      // Clear button
      const inputClearBtn = document.createElement('button');
      inputClearBtn.innerText = '×';
      // inputClearBtn.style = `
      //   position: absolute; right: 10px; top: 35%; transform: translateY(-50%);
      //   font-size: 22px; width: 28px; height: 28px; line-height: 28px; text-align: center;
      //   border: none; border-radius: 50%; background: rgba(0,0,0,0.1);
      //   cursor: pointer; display: flex; align-items: center; justify-content: center;
      // `;

      // Clear button
      inputClearBtn.style = `
        position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
        font-size: 22px; width: 28px; height: 28px; line-height: 28px; text-align: center;
        border: none; border-radius: 50%; background: rgba(0,0,0,0.1);
        cursor: pointer; display: flex; align-items: center; justify-content: center;
        margin-top: 22px
      `;


      inputWrapper.appendChild(inputClearBtn);

      // Results container
      const resultsContainer = document.createElement('div');
      resultsContainer.className = 'thb-predictive-search--container';
      resultsContainer.style = `
        width: 100%; background: #fff;
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        max-height: 800px; overflow-y: auto; z-index: 1000; margin-top: 2px;
        pointer-events: auto; font-size: 12px;
      `;
      

      inputWrapper.appendChild(resultsContainer);

      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      // Focus input
      // requestAnimationFrame(() => setTimeout(() => searchInput.focus(), 50));
      requestAnimationFrame(() => searchInput.focus());


      // Clear button click
      inputClearBtn.addEventListener('click', () => {
        searchInput.value = '';
        resultsContainer.innerHTML = '';
        searchInput.focus();
      });

      
      // Close overlay
      closeBtn.addEventListener('click', () => {
        overlay.remove();
        // document.body.style.overflow = 'auto';

        document.body.style.overflow = ''; 
        document.documentElement.style.overflow = '';
        document.body.classList.remove('open-search'); 
        document.documentElement.classList.remove('open-search');

        if (!originalParent.contains(searchInput)) originalParent.appendChild(searchInput);
        searchInput.value = '';
        const oldResults = originalParent.querySelector('.thb-predictive-search--container');
        if (oldResults) oldResults.remove();
        // searchInput.focus();
        searchInput.blur();

      });



      // Input event for predictive search
      searchInput.addEventListener('input', debounce(function() {
        const query = searchInput.value.trim();
        if (query.length < 2) {
          resultsContainer.innerHTML = '';
          return;
        }

        // Fetch products, collections, queries
        const productUrl = `/search/suggest?q=${encodeURIComponent(query)}&resources%5Btype%5D=product&resources%5Blimit%5D=10&section_id=predictive-search`;
        const collectionUrl = `/search/suggest?q=${encodeURIComponent(query)}&resources%5Btype%5D=collection&resources%5Blimit%5D=10&section_id=predictive-search`;
        const queryUrl = `/search/suggest?q=${encodeURIComponent(query)}&resources%5Btype%5D=query&resources%5Blimit%5D=10&section_id=predictive-search`;

        Promise.all([fetch(productUrl), fetch(collectionUrl), fetch(queryUrl)])
          .then(responses => Promise.all(responses.map(r => r.text())))
          .then(([productText, collectionText, queryText]) => {
            const parser = new DOMParser();

            // Products
            const productDoc = parser.parseFromString(productText, 'text/html');
            const productItems = productDoc.querySelectorAll('.product-cart-item');
            const limitedProducts = Array.from(productItems).slice(0, 5).map(el => el.outerHTML).join('');

            // Collections
            const collectionDoc = parser.parseFromString(collectionText, 'text/html');
            const collectionContent = collectionDoc.querySelector('.thb-predictive-search--content');
            const collectionResults = collectionContent ? collectionContent.innerHTML : '';

            // Queries
            const queryDoc = parser.parseFromString(queryText, 'text/html');
            const queryContent = queryDoc.querySelector('.thb-predictive-search--content');
            const queryResults = queryContent ? queryContent.innerHTML : '';

            // Footer
            const viewAllButton = productDoc.querySelector('.thb-predictive-search--footer');

            // Final markup
            resultsContainer.innerHTML = `
              <div class="thb-predictive-search--content">
                ${limitedProducts}
                ${collectionResults}
                ${queryResults}
              </div>
              ${viewAllButton ? viewAllButton.outerHTML : ''}
            `;
            
      // Reduce spacing between products
      const productItemsInOverlay = resultsContainer.querySelectorAll('.product-cart-item');
      productItemsInOverlay.forEach(item => {
        item.style.marginBottom = '0'; // reduce vertical gap
        item.style.padding = '0 0';    // optional: reduce padding inside item
      });


                const imgs = resultsContainer.querySelectorAll('img');
                imgs.forEach(img => {
                  img.style.width = '40px';   // mobile size
                  img.style.height = '40px';
                  img.style.objectFit = 'cover';
                });
          })
          .catch(err => {
            console.error(err);
            resultsContainer.innerHTML = '<p>Error fetching results</p>';
          });
          resizeImages();
      }, 300));


      resultsContainer.addEventListener('click', function(e) {
        const btn = e.target.closest('#search-results-submit'); 
        if (!btn) return;

        e.preventDefault();   
        e.stopPropagation();  
        

        const searchQuery = encodeURIComponent(searchInput.value.trim());
        const href = `/search?q=${searchQuery}`;

        // // Overlay हटाओ
        // if (!originalParent.contains(searchInput)) {
        //     originalParent.appendChild(searchInput);
        // }
        
        resultsContainer.innerHTML = '';

        overlay.remove();
        document.body.style.overflow = 'auto';

        searchInput.blur();  // force blur to reset click state


        const shopifyPredictive = originalParent.querySelector('.thb-predictive-search--container');
        if (shopifyPredictive) shopifyPredictive.style.display = 'none';

        // Redirect
        window.location.href = href;

        
        // setTimeout(() => {
        //   window.location.href = href;
        // }, 50);
      });

    }
  });
});

// Debounce function
function debounce(fn, delay) {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

